import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuthSuperadmin } from "./SuperadminAuthContext";

const NAV = [
  { ruta: "/superadmin", etiqueta: "Panel" },
  { ruta: "/superadmin/estudios", etiqueta: "Estudios" },
  { ruta: "/superadmin/catalogos", etiqueta: "Materias y Fueros" },
];

// Shell deliberadamente propio, sin relación con Sidebar/MODULOS del estudio —
// la plataforma y los estudios son dos superficies separadas.
export function SuperadminLayout() {
  const { superadmin, cerrarSesion } = useAuthSuperadmin();
  const navegar = useNavigate();

  async function manejarSalir() {
    await cerrarSesion();
    navegar("/superadmin/login", { replace: true });
  }

  return (
    <div className="min-h-screen bg-slate-950">
      <header className="flex h-14 items-center justify-between border-b border-slate-800 px-6">
        <div className="flex items-center gap-2.5">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-white text-sm font-semibold text-slate-900">
            J
          </div>
          <span className="text-sm font-semibold text-white">
            Plataforma JVD — Panel de administración
          </span>
          <nav className="ml-6 flex gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.ruta}
                to={item.ruta}
                end={item.ruta === "/superadmin"}
                className={({ isActive }) =>
                  `text-sm font-medium ${isActive ? "text-white" : "text-slate-400 hover:text-slate-200"}`
                }
              >
                {item.etiqueta}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-4 text-sm">
          <span className="text-slate-400">{superadmin?.nombre_completo}</span>
          <button
            onClick={manejarSalir}
            className="font-medium text-slate-300 hover:text-white"
          >
            Salir
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
